import { createFileRoute, Outlet } from '@tanstack/react-router'

import { LightThemeScope } from '@/components/base'
import { CustomerShell } from '@/components/Customer/Shell'
import { useBareChrome } from '@/hooks/use-bare-chrome'
import { requireAuth } from '@/utils/require-auth'

/**
 * Everything the customer sees, inside the shell.
 *
 * The configurator is the exception: it is a full-height surface with its own
 * step bar and must not sit in a scrolling content column.
 */
function CustomerLayout() {
  if (useBareChrome()) {
    return (
      <LightThemeScope className="flex min-h-0 flex-1">
        <Outlet />
      </LightThemeScope>
    )
  }

  return (
    <CustomerShell>
      <Outlet />
    </CustomerShell>
  )
}

export const Route = createFileRoute('/customer')({
  beforeLoad: async ({ context, location }) => {
    await requireAuth(context.queryClient, location.href)
  },
  component: CustomerLayout,
})
